import { CommonModule } from '@angular/common';
import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';

import { getFormattedUrl } from '@shure/cloud/shared/ui/components';
import {
	PRISM_DIALOG_DATA,
	PrismButtonComponent,
	PrismDialogComponent,
	PrismDialogRef,
	PrismMenuComponent,
	PrismMenuItemComponent,
	PrismSelectComponent,
	TextValueAccessor
} from '@shure/prism-angular-components';

@Component({
	selector: 'sh-grant-access-dialog',
	imports: [
		CommonModule,
		FormsModule,
		TranslocoModule,
		ReactiveFormsModule,
		TextValueAccessor,
		PrismSelectComponent,
		PrismDialogComponent,
		PrismMenuComponent,
		PrismMenuItemComponent,
		PrismButtonComponent
	],
	templateUrl: './grant-access-dialog.component.html',
	styleUrls: ['./grant-access-dialog.component.scss']
})
export class GrantAccessDialogComponent implements OnInit {
	public enteredOrgName!: string;
	public grantAccessFormGroup!: FormGroup;
	public getFormattedUrl = getFormattedUrl;
	public durationOptions = [
		{ label: 'hour', value: 60, labelValue: '1' },
		{ label: 'hours', value: 120, labelValue: '2' },
		{ label: 'hours', value: 360, labelValue: '6' },
		{ label: 'hours', value: 1440, labelValue: '24' },
		{ label: 'days', value: 2880, labelValue: '2' },
		{ label: 'week', value: 10080, labelValue: '1' }
	];
	public isExtendAccess!: boolean;
	public dataContent = {
		title: '',
		description1: '',
		description2: '',
		description3: '',
		formLabel: '',
		buttonLabel: ''
	};
	constructor(
		public formBuilder: FormBuilder,
		private dialogRef: PrismDialogRef<GrantAccessDialogComponent>,
		@Inject(PRISM_DIALOG_DATA) public data: { isExtendAccess: boolean; expiryTime: { dateTime: string } },
		private readonly translocoService: TranslocoService
	) {}

	// HostListener to listen for the "Enter" keypress and trigger form validation
	@HostListener('window:keydown.enter', ['$event'])
	public handleEnterKey(event: KeyboardEvent): void {
		event.preventDefault();
		this.confirmGrantAccess();
	}

	public ngOnInit(): void {
		this.isExtendAccess = !!this.data?.isExtendAccess;
		if (this.isExtendAccess) {
			this.dataContent = {
				...this.dataContent,
				title: this.translocoService.translate('cloud.shared.elevated-access.extend-access'),
				description1: this.translocoService.translate('cloud.shared.elevated-access.extend-access-descrption', {
					dateTime: this.data?.expiryTime.dateTime
				}),
				formLabel: this.translocoService.translate('cloud.shared.elevated-access.amount-of-time-to-add'),
				buttonLabel: this.translocoService.translate('cloud.shared.elevated-access.extend-access')
			};
		} else {
			this.dataContent = {
				title: this.translocoService.translate('cloud.shared.elevated-access.grant-access-title'),
				description1: this.translocoService.translate(
					'cloud.shared.elevated-access.grant-access-description-1'
				),
				description2: this.translocoService.translate(
					'cloud.shared.elevated-access.grant-access-description-2'
				),
				description3: this.translocoService.translate(
					'cloud.shared.elevated-access.grant-access-description-3'
				),
				formLabel: this.translocoService.translate('cloud.shared.elevated-access.choose-duration'),
				buttonLabel: this.translocoService.translate('cloud.shared.elevated-access.grant-access')
			};
		}

		this.buildFormGroup();
	}

	public buildFormGroup(): void {
		this.grantAccessFormGroup = this.formBuilder.group({
			durationMinutes: new FormControl('', [Validators.required])
		});
	}

	public closeDialog(): void {
		this.dialogRef.close();
	}

	public confirmGrantAccess(): void {
		this.dialogRef.close({ data: this.grantAccessFormGroup.value });
	}
}
